import React,  { useContext } from "react";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { CSVLink } from "react-csv";
import { FaFileExport } from "react-icons/fa6";
import { storeContext } from "../../provider/Provider";
import { digitalPRActions } from "../../../store/digital-pr-reducer";
import useLoadLinksDialog from "../hooks/useLoadLinksDialog";
import CustomTable from "../../common/CustomTable";
import { useLinkDialog } from "../hooks/useLinkDialog";
import SkeletonWrapper from "../../common/SkeletonWrapper";
import { useStyles } from "../styles/index.style";

const LinksDialog = () => {
   const { state, dispatch } = useContext(storeContext);
   const { linkColumns, style, filteredLinks, } = useLinkDialog();
   const classes = useStyles();

   useLoadLinksDialog();

   const handleClose = () => {
      
      dispatch({
         type: digitalPRActions.SET_SELECTED_CAMPAIGN,
         payload: { 
            selectedCampaign: null,
         }
      })
      dispatch({
         type: digitalPRActions.SET_LINKS_DIALOG_OPEN,
         payload: { 
            linksDialogOpen: false,
         }
      })
   }

   if(!state.digitalPR.selectedCampaign){
      return null;
   }

   return (
      <Dialog
         open={state.digitalPR.linksDialogOpen}
         onClose={handleClose}
         className={classes.linkListPopup}
      >
         <DialogTitle>
            <Box display="flex" justifyContent="space-between" alignItems="baseline" width="100%">
               <p>{state.digitalPR.selectedCampaign.topic}</p>
               <CSVLink
                  data={state.digitalPR.linkList}
                  filename={`ctm_${state.digitalPR.selectedCampaign.topic}.csv`}
                  style={{
                    color: '#53b9d1',
                    fontSize: '1.2rem',
                    textDecoration: 'none',
                  }}
                >
                  <span style={{height:"1.15rem", paddingRight: "2px", overflow:"hidden", display:"inline-flex"}}>
                     <FaFileExport />
                  </span>
                  <span style={{paddingBottom: "8px"}}>Export</span>
                </CSVLink>
            </Box>
         </DialogTitle>
         <DialogContent>
            <SkeletonWrapper condition={state.digitalPR.linksLoading}>
               <CustomTable
                  data={filteredLinks} 
                  columns={linkColumns} 
                  style={style} 
                  condensed
                  />
            
            </SkeletonWrapper>
         </DialogContent>
         <DialogActions>
            <Box onClick={handleClose} padding="20px 35px 10px" fontSize="16px" style={{cursor: 'pointer'}}>Close</Box>
         </DialogActions>
      </Dialog>)
}

export default LinksDialog
